<template>
  <div class="buy-tokens-card">
    <ui-token
        :tokens="user?.balance || 0"
        class="buy-tokens-card__token"
    />

    <button
        class="btn btn-violet buy-tokens-card__btn"
        @click.stop="openModal(ModalIds.BUY_TOKENS)"
    >
      +
    </button>
  </div>
</template>

<script lang="ts" setup>
import {useStore} from "~/store";
import {useModalStore} from "~/store/modal";
import {ModalIds} from "~/types/Modals";

const {user} = useStore()
const {openModal} = useModalStore()
</script>

<style lang="scss" scoped>
.buy-tokens-card {
  padding: 4px 4px 4px 12px;
  border-radius: 10px;
  background: var(--surfaces-high-container);
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  font-weight: 400;
  height: unset;

  &__token {
    font-size: 14px;
    font-weight: 600;
  }

  .buy-tokens-card__btn {
    border-radius: 8px;
    font-size: 24px;
    font-weight: 400;
    line-height: 24px;
    flex: 0 0;
    width: 36px;
    height: 36px;

    &:hover {
      background: var(--accent-on-surface);
    }
  }
}
</style>
